import $ from 'jquery';
export const init = async function() {
    let itemPos = $('.CollItem:first').position().top;
    // update on resize
    $(window).resize(function() {
        itemPos = $('.CollItem:first').position().top;
    });
    // show scroll-top after pass first row
    $(window).scroll(function() {
        const currentPos = $(window).scrollTop() || 0;
        if (currentPos > itemPos) {
            $('.js-scroll-top').fadeIn();
        } else {
            $('.js-scroll-top').fadeOut();
        }
    });
    // scroll top on click
    $('.js-scroll-top').on('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
};
